<script setup lang="ts">
import type { VoixMediaFieldInterface } from '~/src/runtime/types'

import VoixMediaField from './VoixMediaField.vue'
import VoixMediaString from './VoixMediaString.vue'

defineProps<{
  field: VoixMediaFieldInterface
  currentBreakpoint?: string
  background?: boolean
  loading?: 'lazy' | 'eager'
  debug?: boolean
}>()

function getRenderModel(fieldEntry: VoixMediaFieldInterface) {
  // If the user passed in a string or the default value on a field is being used
  // because no media has been selected
  if (fieldEntry && (typeof fieldEntry === 'string' || typeof fieldEntry.value === 'string'))
    return 'String'

  // A regular field was passed
  if (typeof fieldEntry === 'object')
    return 'Field'

  return undefined
}

function getRenderType(fieldEntry: VoixMediaFieldInterface) {
  const renderModel = getRenderModel(fieldEntry)
  if (renderModel === 'String')
    return VoixMediaString
  if (renderModel === 'Field')
    return VoixMediaField

  return undefined
}
</script>

<template>
  <template v-for="(media, index) in field" :key="index">
    <component
      :is="getRenderType(media)"
      :field="media"
      :background="background"
      :loading="loading"
      :debug="debug"
      v-bind="$attrs"
      v-on="$attrs"
    />
  </template>
</template>
